import { render, staticRenderFns } from "./BucketSpinner.vue?vue&type=template&id=28228915&scoped=true"
import script from "./BucketSpinner.vue?vue&type=script&lang=js"
export * from "./BucketSpinner.vue?vue&type=script&lang=js"
import style0 from "./BucketSpinner.vue?vue&type=style&index=0&id=28228915&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28228915",
  null
  
)

export default component.exports